import { Injectable } from '@angular/core';
import { CommonDataService } from 'src/sb-tools/typescript/services/common-data.service';
import { TicketAccessService } from './ticket-access.service';
import { UserRole } from '@sb-tools/typescript/enums/user-role.enum';
import { TranslateService } from '@ngx-translate/core';
import { DetailedTicketDTO } from '../../../core/models/dto/detailed-ticket.dto';
import { TicketAssigneeUpdateModel } from '../../../core/models/ticket-assignee-update.model';
import { CommunityUser } from '@sb-tools/typescript/models/community-user.model';
import { BaseUserWithRole } from '@sb-tools/typescript/models/base-user-with-role.model';

@Injectable({
    providedIn: 'root',
})
export class AssignService {
    isAssigningTicket: boolean;
    isNotAssignedToCurrentUser: boolean;
    isAssignedToCurrentUser: boolean;
    isShowAssigningSelect: boolean;
    usersForAssign: CommunityUser[] = [];

    constructor(
        private commonDataService: CommonDataService,
        private ticketAccessService: TicketAccessService,
        private translateService: TranslateService,
    ) {}

    getIsNotAssignedToCurrentUserStatus(isAssigned: boolean): boolean {
        if (this.commonDataService.isOneTime) {
            return false;
        } else {
            return (
                (isAssigned && !this.isAssignedToCurrentUser) ||
                (this.commonDataService.customerSettings.isTicketAssigningObligatory && !isAssigned)
            );
        }
    }

    loadUsersForAssign(ticket: DetailedTicketDTO): void {
        this.ticketAccessService.get(ticket.id).subscribe((data) => {
            ticket.teammatesWithAccess = this.sortUsersForAssign(data.teammates);
            this.usersForAssign = this.sortUsersForAssign(data.teammates);
        });
    }

    showAlertOnTicketAssigned(
        currentTicket: DetailedTicketDTO,
        updatedTicket: DetailedTicketDTO | TicketAssigneeUpdateModel,
    ): void {
        if (
            updatedTicket.assignee?.id !== currentTicket.assignee?.id &&
            updatedTicket.isAssigned &&
            updatedTicket.assignerId !== this.commonDataService.user.id &&
            updatedTicket.assignee?.id !== this.commonDataService.user.id &&
            !updatedTicket.isAssignedToBot &&
            this.commonDataService.user.role !== UserRole.vendor &&
            this.commonDataService.user.role !== UserRole.readOnlyUser
        ) {
            alert(
                updatedTicket.assignee.name +
                    ' ' +
                    this.translateService.instant(
                        'has assigned this ticket! You cannot do any actions on this ticket while it is assigned to another user!',
                    ),
            );
        }
    }

    showAssigningSelect($event): void {
        if (this.isAssigningTicket) {
            return;
        }

        $event.stopPropagation();

        if (!this.isShowAssigningSelect) {
            this.isShowAssigningSelect = true;
        }
    }

    sortUsersForAssign(users: CommunityUser[] | BaseUserWithRole[] | any): CommunityUser[] | BaseUserWithRole[] | any {
        users = [this.commonDataService.user].concat(
            users.filter((user) => {
                return user.id !== this.commonDataService.user.id;
            }),
        );

        users.forEach((item) => {
            item.label = item.name ? item.name + ' ' + item.email : item.email;
        });

        return users;
    }
}
